export class ScrollService {
  static getScrollBottom(element) {
    return element.scrollHeight - Math.round(element.scrollTop) - Math.round(element.clientHeight);
  }

  static getScrollTop(element) {
    return element.scrollTop;
  }
}
